import request from './zz'

// 查看
export function view(id) {
  return request({
    url: '/account/info/view',
    method: 'get',
    params: { id: id }
  })
}

// 分页查询
export function page(params) {
  return request({
    url: '/account/info/page',
    method: 'get',
    params
  })
}

// 保存
export function save(data) {
  return request({
    url: '/account/info/save',
    method: 'post',
    data
  })
}

// 删除
export function del(data) {
  return request({
    url: '/account/info/del',
    method: 'post',
    data
  })
}

// 设置密码
export function modifyPasswordAnyone(params) {
  return request({
    url: '/account/info/modify_password',
    method: 'post',
    data: params
  })
}

// 设置密码
export function modifyPasswordSelf(params) {
  return request({
      url: "/security/account/modify_password",
      method: "post",
      data: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/platform/account/accountInfo.js